/* eslint-disable prettier/prettier */
// import { useState } from 'react'
import PropTypes from 'prop-types'
import { CardTitle } from '@usb-ui-tools/react-billpay-layout'
import { useState } from 'react'
import { useMultilingualService } from '../../../../../service/multilingualService'
import { isOLBOrIpadApp } from '../../../../../utils/browserutils'

const VerifybillsHeader = ({
  isFieldsValidationError,
  pageErrorMsg,
  submitStatus,
  verifyLength,
  errorNotificaitonText,
  count
}) => {
  const { VERIFY_BILLS } = useMultilingualService('findbills')
  const [notificationStatus, setNotificationStatus] = useState(true)


  return (
    <CardTitle
      {...{
        notificationArray: [
          {
            type: 'information',
            message: (
              <div style={{ marginRight: '1rem' }}>
                {VERIFY_BILLS.VEERIFY_NOTIFICATION_TEXT}               
              </div>
            ),
            show:
              notificationStatus &&
              !submitStatus &&
              verifyLength > 0 &&
              !errorNotificaitonText &&
              count < 4,
            handleCloseFunction: () => {
              setNotificationStatus(false)
            }
          },
          {
            type: 'error',
            message: pageErrorMsg,
            show: isFieldsValidationError
          }
        ],
        showAvatar: false,
        pageTitleText: VERIFY_BILLS?.HEADER?.VERIFY_BILL_HEADER,
        id: 'verify-bills',
        cardTitleTextSameAsPageTitleText: true,
        isOLBOrIpadApp,
        gapThruMarginTop: true,
        cardOtherBlockProps: { mobileTopMargin: '0' }
      }}
    />
  )
}

VerifybillsHeader.propTypes = {
  isFieldsValidationError: PropTypes.bool.isRequired,
  pageErrorMsg: PropTypes.string.isRequired,
  submitStatus: PropTypes.bool.isRequired,
  verifyLength: PropTypes.number.isRequired,
  errorNotificaitonText: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired
}
export default VerifybillsHeader
